import { render, staticRenderFns } from "./about.vue?vue&type=template&id=f8acdf40"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"
import style0 from "./about.vue?vue&type=style&index=0&id=f8acdf40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports